import {
  SET_MY_QUESTS_AUTHOR_FILTER,
  SET_MY_QUESTS_KEYWORD_FILTER,
  SET_MY_QUESTS_DRAFT_FILTER,
  SET_MY_QUESTS_STATUS_FILTER,
  SET_MY_QUESTS_ASSIGNED_TO_FILTER
} from '../actions/myquestsfilters'

const initialState = {
  authors_id_in: [],
  quest_draft_or_state_in: [],
  reviewing_compiled_quest_state_in: [],
  name_or_description_cont: '',
  quest_subject_id_in: [],
  assigned_to_id_in: []
}

export function myquestsfilters(state = initialState, action) {
  switch (action.type) {
    case SET_MY_QUESTS_AUTHOR_FILTER:
      return Object.assign({}, state, {
        authors_id_in: action.authors_id_in
      })
    case SET_MY_QUESTS_KEYWORD_FILTER:
      return Object.assign({}, state, {
        name_or_description_cont: action.name_or_description_cont
      })
    case SET_MY_QUESTS_DRAFT_FILTER:
      return Object.assign({}, state, {
        quest_draft_or_state_in: action.quest_draft_or_state_in
      })
    case SET_MY_QUESTS_STATUS_FILTER:
      return Object.assign({}, state, {
        reviewing_compiled_quest_state_in:
          action.reviewing_compiled_quest_state_in
      })
    case SET_MY_QUESTS_ASSIGNED_TO_FILTER:
      return Object.assign({}, state, {
        assigned_to_id_in: action.assigned_to_id_in
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/myquestsfilters.js